import React from 'react'
import styled from 'styled-components'
import { Set } from 'immutable'

import { primary, borderColor, white } from 'styles/colors'

import Plus from 'components/icons/Plus'
import X from 'components/icons/X'
import { InputWithSuggestions } from 'components/form'

const Wrapper = styled.div`
  width: 100%;
`

const TagsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -5px;
`

const Tag = styled.div`
  margin: 5px;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  font-size: 14px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
`

const Text = styled.div`
  margin-right: 8px;
`

const InputGroup = styled.div`
  display: flex;
  margin-bottom: 10px;
  width: 100%;
`

const Button = styled.button`
  margin-left: 5px;
  flex-shrink: 0;
  padding: 0;
  width: 40px;
  height: 40px;
  background-color: ${primary};
  border: 1px solid ${primary};
  border-radius: 4px;

  &:disabled {
    background-color: ${white};
    border-color: ${borderColor};
  }
`

class TagsInput extends React.Component {
  state = {
    input: '',
  }

  addTag = tag => {
    this.props.onChange(Set([...this.props.value, tag]).toArray())
    this.setState({ input: '' })
  }

  removeTag = tag => {
    this.props.onChange(
      Set(this.props.value)
        .remove(tag)
        .toArray()
    )
  }

  render() {
    return (
      <Wrapper>
        <InputGroup>
          <InputWithSuggestions
            suggestionsType="tag"
            value={this.state.input}
            onChange={e => this.setState({ input: e.target.value })}
            select={tag => tag && this.addTag(tag)}
            exclusions={this.props.value}
          />
          <Button
            type="button"
            disabled={!this.state.input.length}
            onClick={() => this.addTag(this.state.input)}>
            <Plus color={!this.state.input.length ? borderColor : white} />
          </Button>
        </InputGroup>
        <TagsList>
          {this.props.value.map(tag => (
            <Tag key={tag}>
              <Text>{tag}</Text>
              <X onClick={() => this.removeTag(tag)} />
            </Tag>
          ))}
        </TagsList>
      </Wrapper>
    )
  }
}

export default TagsInput



// WEBPACK FOOTER //
// ./src/components/form/TagsInput.js